export default __webpack_public_path__ + "static/startNightYoon-64db1597aea5936ba9b9ed96f5139c10.png";